module.exports = __webpack_public_path__ + "img/typography_splash.2866dedd.jpg";